import * as THREE from 'three'

import shaderFragment from '../../shaders/shadow/fragment.glsl'
import shaderVertex from '../../shaders/shadow/vertex.glsl'

export default function()
{
    return new THREE.ShaderMaterial({
        transparent: true,
        depthWrite: false,
        uniforms: {
            uColor: { value: null },
            uAlpha: { value: null },
            uFadeRadius: { value: null }
        },
        vertexShader: shaderVertex,
        fragmentShader: shaderFragment
    })
}
